import {observable} from "mobx";
import {ListItemViewModel} from "../../../../../infrastructure/models/list-item.view-model";

export class BaseHeaderListItemViewModel extends ListItemViewModel {
  @observable isLive: Boolean = false;
  isStandings: Boolean;
  isBrackets: Boolean;
  isStats: Boolean;
  isSquad: Boolean;
  isTransfers: Boolean;
  isBolao: Boolean;

  constructor(model: BaseHeaderListItemViewModel) {
    super(model);

    this.isLive = model.isLive;
    this.isStandings = model.isStandings;
    this.isBrackets = model.isBrackets;
    this.isStats = model.isStats;
    this.isSquad = model.isSquad;
    this.isTransfers = model.isTransfers;
    this.isBolao = model.isBolao;
  }
}
